var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.662,
    height: 97.662,
    viewBox: "0 0 97.662 97.662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bin_Ico",
    "data-name": "Bin Ico",
    transform: "translate(0 9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6677",
    "data-name": "Rect\\xE1ngulo 6677",
    width: 97.662,
    height: 97.662,
    transform: "translate(0 -9)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20010",
    "data-name": "Trazado 20010",
    d: "M19.281-.505A1.511,1.511,0,0,1,18.2-.9a1.463,1.463,0,0,1-.439-1.06l-.7-24.421a1.394,1.394,0,0,1,.407-1.049,1.507,1.507,0,0,1,1.1-.4,1.524,1.524,0,0,1,1.089.39A1.435,1.435,0,0,1,20.1-26.4l.7,24.44a1.315,1.315,0,0,1-.4,1.052A1.557,1.557,0,0,1,19.281-.505Zm6.842,0A1.6,1.6,0,0,1,25-.905,1.353,1.353,0,0,1,24.56-1.95v-24.43A1.353,1.353,0,0,1,25-27.426a1.6,1.6,0,0,1,1.127-.4,1.557,1.557,0,0,1,1.114.4,1.371,1.371,0,0,1,.424,1.045V-1.95a1.37,1.37,0,0,1-.424,1.045A1.558,1.558,0,0,1,26.123-.505Zm6.817,0a1.519,1.519,0,0,1-1.109-.4,1.4,1.4,0,0,1-.41-1.052l.706-24.419a1.45,1.45,0,0,1,.438-1.057,1.525,1.525,0,0,1,1.088-.39,1.51,1.51,0,0,1,1.1.4,1.4,1.4,0,0,1,.407,1.049L34.458-1.933A1.439,1.439,0,0,1,34.02-.9,1.51,1.51,0,0,1,32.94-.505ZM15.8-34.056v-5.086A5.281,5.281,0,0,1,17.367-43.2,6.1,6.1,0,0,1,21.7-44.662h8.769A6.139,6.139,0,0,1,34.821-43.2,5.261,5.261,0,0,1,36.4-39.142v5.086h-4v-4.873a1.97,1.97,0,0,0-.594-1.5,2.228,2.228,0,0,0-1.6-.565H21.976a2.237,2.237,0,0,0-1.591.565,1.951,1.951,0,0,0-.605,1.5v4.873ZM5.419-31.864A1.813,1.813,0,0,1,4.1-32.417a1.841,1.841,0,0,1-.558-1.361A1.806,1.806,0,0,1,4.1-35.11a1.815,1.815,0,0,1,1.321-.552H46.8a1.8,1.8,0,0,1,1.331.552,1.823,1.823,0,0,1,.548,1.333,1.858,1.858,0,0,1-.548,1.361,1.8,1.8,0,0,1-1.331.553ZM15.513,7.143a5.781,5.781,0,0,1-4.157-1.5,5.781,5.781,0,0,1-1.7-4.083L8.06-32.306h3.927L13.6,1.014a2.447,2.447,0,0,0,.7,1.661,2.2,2.2,0,0,0,1.632.657H36.274a2.244,2.244,0,0,0,1.654-.646,2.431,2.431,0,0,0,.7-1.672l1.543-33.319h4.015L42.566,1.54a5.813,5.813,0,0,1-1.7,4.094A5.73,5.73,0,0,1,36.73,7.143Z",
    transform: "translate(25 57.662)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBlack);
export default __webpack_public_path__ + "static/media/delete-black.0d43e8e24d54823b062f331aeec0da69.svg";
export { ForwardRef as ReactComponent };